import React from 'react';
import { FaFacebook, FaUsers, FaInfoCircle } from 'react-icons/fa';
import RichText from '../ui/RichText';
import '../../css/common/ParentsCard.css';

const ParentsCard = ({ resource }) => {
  const getIcon = (iconType) => {
    switch (iconType) {
      case 'facebook':
        return <FaFacebook />;
      case 'network':
        return <FaUsers />;
      case 'resources':
        return <FaInfoCircle />;
      default:
        return <FaInfoCircle />;
    }
  };

  const handleClick = (e) => {
    if (resource.external) {
      e.preventDefault();
      window.open(resource.link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className={`parents-card ${resource.featured ? 'featured' : ''}`}>
      <div className="parents-card-header">
        <div className="parents-card-icon">
          {getIcon(resource.icon)}
        </div>
        <h3 className="parents-card-title">{resource.title}</h3>
      </div>
      
      <RichText value={resource.description} className="parents-card-description" />
      
      <a 
        href={resource.link} 
        className="parents-card-link"
        onClick={handleClick}
        target={resource.external ? "_blank" : undefined}
        rel={resource.external ? "noopener noreferrer" : undefined}
      >
        {resource.linkText}
      </a>
    </div>
  );
};

export default ParentsCard; 